import _, { get } from "lodash";

export const formatStationDataInTreeToID = (
  station,
  listStation,
  provinces,
  regions,
  stations
) => {
  let num = [];
  let str = [];

  for (var i = 0; i < station.length; i++) {
    if (isNaN(Number(station[i]))) {
      str.push(station[i]);
    } else {
      num.push(station[i]);
    }
  }

  if (str.length) {
    let stationByRegion = str.map((e) => {
      return _.filter(listStation, {
        region_name: e,
      });
    });

    let merStationByRegion = stationByRegion[0];

    for (var i = 1; i < stationByRegion.length; i++) {
      merStationByRegion = merStationByRegion.concat(stationByRegion[i]);
    }

    const provinces = listStation[0].provinces.concat(
      listStation[1].provinces,
      listStation[2].provinces
    );

    const stationByProvince = str.map((e) => {
      return _.filter(provinces, {
        province_name: e,
      });
    });

    let merStationByProvince = stationByProvince[0];

    for (var i = 1; i < stationByProvince.length; i++) {
      merStationByProvince = merStationByProvince.concat(stationByProvince[i]);
    }

    const province_id = merStationByProvince.map((e) => {
      return e.province_id;
    });

    const region_id = merStationByRegion.map((e) => {
      return e.region_id;
    });
    return {
      station_id: num,
      province_id: province_id,
      region_id: region_id,
    };
  } else {
    const regionInfo = _.map(listStation, (e) => {
      return {
        id: e.region_id,
        len: _.reduce(
          e.provinces,
          (sum, n) => {
            return sum + _.size(n.stations);
          },
          0
        ),
      };
    });

    const provinceInfo = _.map(
      _.concat(
        listStation[0].provinces,
        listStation[1].provinces,
        listStation[2].provinces
      ),
      (e) => {
        return {
          id: e.province_id,
          len: _.size(e.stations),
        };
      }
    );

    const filtered = _.filter(stations, (e) => {
      return _.includes(num, e.id);
    });
    const groupByRegion = _.groupBy(filtered, "region");
    const region_id = _.remove(Object.keys(groupByRegion), (id) => {
      for (let region of regionInfo) {
        if (region.id === id) {
          return region.len === _.size(groupByRegion[id]);
        }
      }
    });

    const regionIdRest = _.remove(Object.keys(groupByRegion), (id) => {
      return !_.includes(region_id, id);
    });

    // check size region rest
    if (_.size(regionIdRest)) {
      let province = groupByRegion[regionIdRest[0]];
      for (let i = 1; i < _.size(regionIdRest); i++) {
        province = _.concat(province, groupByRegion[regionIdRest[i]]);
      }
      const groupByProvinceId = _.groupBy(province, "province_id");
      const province_id = _.remove(Object.keys(groupByProvinceId), (id) => {
        for (let province of provinceInfo) {
          if (province.id === id) {
            return province.len === _.size(groupByProvinceId[id]);
          }
        }
      });

      const province_rest = _.remove(Object.keys(groupByProvinceId), (id) => {
        return !_.includes(province_id, id);
      });
      // check size province
      if (_.size(province_rest)) {
        let station = groupByProvinceId[province_rest[0]];
        for (let i = 1; i < _.size(province_rest); i++) {
          station = _.concat(station, groupByProvinceId[province_rest[i]]);
        }
        station = _.map(station, (e) => {
          return e.id;
        });
        return {
          station_id: station,
          province_id: province_id,
          region_id: region_id,
        };
      } else
        return {
          station_id: [],
          province_id: province_id,
          region_id: region_id,
        };
    } else
      return {
        station_id: [],
        province_id: [],
        region_id: region_id,
      };
  }
};

export const convertObjToArrObj = (obj) => {
  const keys = Object.keys(obj);
  let verify_modes = [];
  for (let key of keys) {
    verify_modes.push({
      key: key,
      value: obj[key],
    });
  }
  return verify_modes;
};

export const convertStationGate = (data, stations) => {
  const stationIds = [];
  const gateIds = [];

  for (var i = 0; i < data.length; i++) {
    const element = data[i];
    if (isNaN(parseInt(element))) {
      stations.forEach((item) => {
        if (item.station_name === element) {
          stationIds.push(item.station_id);
        }
      });
    } else {
      gateIds.push(parseInt(element));
    }
  }

  return {
    gateIds,
    stationIds,
  };
};

export const getAccessToken = () => {
  let ghtkTokenStorage = localStorage.getItem("ghtk-token-storage");

  if (!ghtkTokenStorage) return "";
  try {
    let ghtkTokenStorageObj = JSON.parse(ghtkTokenStorage);
    return get(ghtkTokenStorageObj, "accessToken.accessToken");
  } catch (error) {
    return "";
  }
};

export const onlyLettersAndNumbers = (str) => {
  return /^[A-Za-z0-9]*$/.test(str);
};

export const convertAllToOptions = (collection, value, label) => {
  return collection?.map((item) => ({
    ...item,
    value: item?.[value],
    label: item?.[label],
  }));
};

export function normalizeText(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
}

export function filterOptions(input, option) {
  return normalizeText(option.label).includes(normalizeText(input));
}

export const filterText = (text, data, field = "name") => {
  return _.filter(data, (item) =>
    item?.[field]?.toLowerCase().includes(text.toLowerCase())
  );
};

export const convertQueryParamsToString = (params) => {
  if (!params || Object.keys(params).length === 0) return "";

  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined) {
          searchParams.append(key, String(item));
        }
      });
    } else {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

function getOptionLabel(item, labelKey, separator = "-") {
  const label = Array.isArray(labelKey)
    ? labelKey.reduce(
        (label, key) =>
          (label ? `${label}${separator}` : label) + (item?.[key] ?? ""),
        ""
      )
    : item[labelKey];

  return label;
}

export function convertToOptions(collection, valueKey, labelKey, separator) {
  if (!Array.isArray(collection)) return [];

  return _.map(collection, (item) => {
    const label = getOptionLabel(item, labelKey, separator);

    return {
      value: item[valueKey],
      label: label,
    };
  });
}
